<div class="row h-100 no-gutters">
  <div class="col-8 border border-primary">
    <ns-grid
      name="TRACK"
      rowSelection="multiple"
      [gridOptions]="fromTrackOptions"
      [config]="fromTrackConfig"
      [data]="fromTrackData"
      [resizeType]="resizeType"
      [loading]="loading"
      (ready)="setFromTrackGrid($event)">
      <ng-from-track-header-container
        [fromTrackGrid]="fromTrackGrid"
        [toTrackGrid]="toTrackGrid"
        (clearTracksOrder)="resetSelectedTracks()"
        grid-header>
      </ng-from-track-header-container>
    </ns-grid>
  </div>
  <div class="col-4 border border-primary d-flex flex-column">
    <ns-grid name="TRACK_INVENTORY"
             class="h-50 border-bottom border-primary"
             [gridTitle]="inventoryGridTitle"
             [gridOptions]="inventoryTrackOptions"
             [config]="inventoryTrackConfig"
             [data]="inventoryTrackData"
             [loading]="loadingToTrack"
             (ready)="setInventoryTrackGrid($event)"
    ></ns-grid>
    <ns-grid name="TRACK_OPTIONS"
             class="h-50"
             rowSelection="multiple"
             [gridOptions]="toTrackOptions"
             [config]="toTrackConfig"
             [data]="toTrackData"
             [loading]="loadingToTrack"
             (ready)="setToTrackGrid($event)">
      <ng-to-track-header-container
        [fromTrackGrid]="fromTrackGrid"
        [toTrackGrid]="toTrackGrid"
        [selectedToTrack]="selectedToTrack"
        grid-header
      ></ng-to-track-header-container>
    </ns-grid>
  </div>
</div>
